import {
  createPortExecutor,
  type SqliteExecutor,
} from '@littlebird/local-db/executor';

export function createWebExecutor(): SqliteExecutor {
  const worker = new Worker(new URL('./local-db.worker.ts', import.meta.url), {
    type: 'module',
  });
  return createPortExecutor(worker);
}
